export default "8c0ff37ae2aaf942.svg"